module.exports = __webpack_public_path__ + "img/b2.b6a8f7a.png";